import React from 'react'
import { Provider } from 'react-redux'
import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { reducer as reduxFormReducer } from 'redux-form'
import createSagaMiddleware from 'redux-saga'
import { Router } from 'react-router-dom'
import { routerMiddleware } from 'react-router-redux'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import { routerReducer } from 'react-router-redux'
import createBrowserHistory from 'history/createBrowserHistory'
import rootSaga from './sagas/rootSaga'
import { reducer as sessionReducer } from './sagas/session'
import { reducer as enforcementReducer } from './sagas/enforcement'
import { reducer as reservationReducer } from './sagas/reservation'
import { reducer as kegSizeReducer } from './sagas/keg_size_options'
import { reducer as productOptionReducer } from './sagas/product_options'
import { reducer as confirmationReducer } from './sagas/reservation/confirmation'
import { reducer as reservationSearchReducer } from './sagas/reservation/search'
import { reducer as reservationIndexReducer } from './sagas/reservation/index'
import { reducer as accountReducer } from './sagas/account'
import { reducer as inventoryReducer } from './sagas/inventory'
import { reducer as inventoryUpdateReducer } from './sagas/inventory/new'
import { reducer as productReducer } from './sagas/products'
import { reducer as customersReducer } from './sagas/customers'
import { reducer as customerReducer } from './sagas/customers/show'
import { reducer as accountingReducer } from './sagas/accounting'
import { reducer as stripeSettingsReducer } from './sagas/stripe_settings'
import { reducer as accountInformationReducer } from './sagas/sign_up/account_information'
import { reducer as newUserReducer } from './sagas/sign_up/new'
import { reducer as NewProductReducer } from './sagas/products/new'
import { reducer as ShowProductReducer } from './sagas/products/show'
import { reducer as UpdateProductReducer } from './sagas/products/update'
import { reducer as CheckoutReducer } from './sagas/checkout'
import { reducer as KegReducer } from './sagas/kegs'
import { reducer as reservationShowReducer } from './sagas/reservation/show'
import { reducer as accountUpdateReducer } from './sagas/account/update'
import { reducer as kegSizesReducer } from './sagas/keg_sizes'
import { reducer as refundReducer } from './sagas/refund'
import { reducer as inviteReducer } from './sagas/inviteUser'

const history = createBrowserHistory()

const sagaMiddleware = createSagaMiddleware()
const routerMWare = routerMiddleware(history)

const rootReducer = combineReducers({
  product_options: productOptionReducer,
  keg_size_options: kegSizeReducer,
  session: sessionReducer,
  routing: routerReducer,
  enforcement: enforcementReducer,
  reservation: reservationReducer,
  form: reduxFormReducer,
  confirmation: confirmationReducer,
  account: accountReducer,
  reservationIndex: reservationIndexReducer,
  reservation_show: reservationShowReducer,
  inventory: inventoryReducer,
  inventoryUpdateReducer: inventoryUpdateReducer,
  product: productReducer,
  customers: customersReducer,
  customer: customerReducer,
  accounting: accountingReducer,
  stripe_settings: stripeSettingsReducer,
  account_information: accountInformationReducer,
  new_user: newUserReducer,
  new_product: NewProductReducer,
  show_product: ShowProductReducer,
  update_product: UpdateProductReducer,
  checkout: CheckoutReducer,
  reservation_search: reservationSearchReducer,
  keg: KegReducer,
  accountUpdate: accountUpdateReducer,
  kegSize: kegSizesReducer,
  refund: refundReducer,
  invite: inviteReducer,
})

const middlewares = compose(
  applyMiddleware(sagaMiddleware, routerMWare),
  process.env.NODE_ENV === 'development' &&
    typeof window !== 'undefined' &&
    typeof window.devToolsExtension !== 'undefined'
      // Call the brower extension function to create the enhancer.
      ? window.devToolsExtension()
      // Else we return a no-op function.
      : (f) => f
)

export const store = createStore(rootReducer, {}, middlewares);

sagaMiddleware.run(rootSaga)

ReactDOM.render(
  <Provider store={ store }>
    <App routerComponent={ Router } history={ history } />
  </Provider>, document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js